import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Cookie } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Small delay so it doesn't pop up instantly on load
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-24 md:bottom-0 left-0 right-0 z-[100] p-4 md:p-6 pointer-events-none flex justify-center"
        >
          <div className="bg-card text-card-foreground border border-border shadow-2xl rounded-2xl p-6 max-w-4xl w-full pointer-events-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-3 rounded-full hidden sm:block shrink-0">
                <Cookie className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-bold text-lg mb-1">
                  Wij gebruiken cookies 🍪
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  We gebruiken cookies om uw ervaring op onze website te
                  verbeteren en voor analytische doeleinden. Lees meer in onze{" "}
                  <Link
                    to="/privacy"
                    className="text-primary hover:underline font-medium"
                  >
                    Privacyverklaring
                  </Link>
                  .
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row items-center gap-3 w-full md:w-auto shrink-0">
              <button
                onClick={handleDecline}
                className="text-xs text-muted-foreground hover:text-foreground underline-offset-4 hover:underline order-2 md:order-1 px-2 py-1"
              >
                Weigeren
              </button>
              <Button
                className="w-full md:w-auto bg-primary text-primary-foreground hover:bg-primary/90 order-1 md:order-2"
                onClick={handleAccept}
              >
                Accepteren
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
